import { ACTIVE_SHIPMENT_DOCUMENT_SIGNATURE_URL } from "actions";
import { Dropdown, Input, Modal } from "components/common"
import { DocumentsContext, HomeContext, ModalContext } from "contexts";
import { useContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useHistory, useLocation } from "react-router-dom";
import { getErrorMessage } from "utils";
import './index.scss';

export const VerifyWalletModal = ({ open, onCancel }) => {
    const history = useHistory();
    const location = useLocation();
    const { handleSubmit,register, errors, reset  } = useForm();
    const [pwdToggle, setPwdToggle] = useState(false);
    const { 
        doGetEthereum, 
    } = useContext(DocumentsContext);
    const { setDirectEndorsement, setSurrenderDocumentModal, setTransferModal, setNominateOwnerShip, setEndorseOwnership } = useContext(ModalContext);
    const [walletSelected, setWalletSelected] = useState();
    const [newWallestByOrg, setNewWallestByOrg] = useState([]);
    const { setCurrentWallest, idDocumentSignature, setInvoking, setInvockingParty, setWalletVerify, optionBlockChain, setOptionBlockChain, idShipment, wallestByOrg } = useContext(HomeContext);
    const pathnameArr = location.pathname.split('/');
    const docId = pathnameArr[pathnameArr.length - 1];
    const shipmentId = pathnameArr[pathnameArr.length -3];

    /*eslint-disable */
    useEffect(() => {
        setNewWallestByOrg(wallestByOrg);
        setWalletSelected({...walletSelected, _id: wallestByOrg[0]?._id, address: wallestByOrg[0]?.address, value: wallestByOrg[0]?.value + ` (${wallestByOrg[0]?.address})`, orgId : wallestByOrg[0]?.orgId})
    }, [wallestByOrg]);
    /*eslint-disable */

    const handleConfirm = (data) => {
        const { walletPassword } = data;
        setCurrentWallest(walletSelected);
        doGetEthereum({
            dltID: idDocumentSignature ? idDocumentSignature : docId,
            orgId: walletSelected.orgId,
            walletPassword: walletPassword
        }, {
            wallet: walletSelected.address, 
            blockchain: "Ethereum",
            orgId: walletSelected.orgId,
        }, (data) => {
            if (data) {
                setInvoking({address: walletSelected.address, password: walletPassword});
                if(walletSelected) setWalletVerify({...walletSelected, orgId: walletSelected?.orgId});
                reset();
                switch (optionBlockChain) {
                    case 1:
                        setDirectEndorsement(true);
                        break;
                    case 2:
                        setSurrenderDocumentModal(true);
                        break;
                    case 3:
                        setTransferModal(true);
                        break;
                    case 4:
                        setNominateOwnerShip(true);
                        break;
                    case 5:
                        setEndorseOwnership(true);
                        break;
                    default:
                        history.push(`${ACTIVE_SHIPMENT_DOCUMENT_SIGNATURE_URL.replace(':shipmentId', idShipment ? idShipment : shipmentId)}/${idDocumentSignature ? idDocumentSignature : docId}`);
                        break;
                };
                setOptionBlockChain('');
                onCancel();
            }
            
        })
    }

    const hanldSelectWallet = (option) => {
        setWalletSelected(option);
        setInvockingParty(option?.address);
    }

    const hanldOnClickIcon = () => {
        setPwdToggle(!pwdToggle);
    }

    const handleSearchWallet = (value) => {
        setNewWallestByOrg(wallestByOrg?.filter(x => x?.value?.toLowerCase().includes(value?.toLowerCase())));
    }

    return (
        <Modal
            open={open}
            className="tr__confirmWallet"
            onCancel={onCancel}
            title="Select wallet"
            submitButton
            submitButtonLabel="Confirm"
            isBackDropClickable={false}
            renderForm={children => (
                <form onSubmit={handleSubmit(handleConfirm)}>
                    {children}
                </form>
            )}
        >
            <div className="dropdow_account">
                <Dropdown
                    label={"Invoking party account *"}
                    options={newWallestByOrg?.map(type => {
                        return {
                            _id: type?._id,
                            key: type?._id,
                            address: type?.address,
                            value: type.value + ` (${type.address})`,
                            orgId: type.orgId
                        }
                    })}
                    placeholder="Invoking party account"
                    iconPosition='right'
                    icon='icon-chevron-down'
                    defaultValue={walletSelected?.value}
                    dropdownPosition="center"
                    onInputChange={handleSearchWallet}
                    onChange={option => hanldSelectWallet(option)}
                    mode="input"
                    name="partyAccount"
                    refs={register({ required: true })}
                    error={!!errors.partyAccount}
                        errorMessage={getErrorMessage(errors.scac, "partyAccount")}

                />
            </div>
            <div className="input_address">
                <Input
                    label={"Invoking party account address *"}
                    placeholder="Invoking party account address"
                    defaultValue={walletSelected?.address}
                    name="walletAddress"
                    disabled={true}
                    refs={register({ required: true })}
                    error={!!errors.walletAddress}
                    errorMessage={getErrorMessage(errors.walletAddress, "walletAddress")}
                />
            </div>
            <div className="input_password">
                <Input
                    label={"Invoking party wallets password *"}
                    placeholder="Invoking party wallets password"
                    name="walletPassword"
                    type={!pwdToggle ? 'password' : 'text'}
                    onIconClick={hanldOnClickIcon}
                    icon={pwdToggle ? "icon-eye-slash" : "icon-eye"}
                    iconPosition="right"
                    refs={register({ required: true })}
                    error={!!errors.walletPassword}
                    errorMessage={getErrorMessage(errors.walletPassword, "walletPassword")}
                />
            </div>
        </Modal>
    )
}
